/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';
import moment from 'moment';

import Select2, { DataSelect2 } from 'wdna-select2';
import { UserDO } from 'wdna-components/lib/types.new';
import UiValidate from 'wdna-components/lib/forms/validation/UiValidate';

import { LovDO } from '../../../types';

interface Props {
  loading?: boolean;
  areaList: LovDO[];
  countryList: LovDO[];
  user: Partial<UserDO>;
  submit: (e: React.FormEvent<HTMLFormElement>) => void;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  handleSelect2: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

/**
 * Function to create a UserInfo component
 *
 * @param props component properties
 * @returns react node component
 */
export default function UserInfo(props: Props): JSX.Element {
  const { loading, user, areaList, countryList, submit, handleChange, handleSelect2 } = props;

  return (
    <UiValidate>
      <form className="smart-form" onSubmit={submit}>
        <fieldset>
          <label className="label">User account</label>

          <section>
            <label className="input">
              <i className="icon-append fa fa-envelope" />
              <input
                type="email"
                name="email"
                value={_.defaultTo(user?.email, '')}
                onChange={handleChange}
                placeholder="Email"
              />
              <b className="tooltip tooltip-bottom-right">Necesario para verificar tu cuenta</b>{' '}
            </label>
          </section>

          <section>
            <label className="label">User Area</label>
            {areaList && (
              <Select2
                name="areaId"
                value={_.defaultTo(user?.areaId, '')}
                data={areaList.map((area: LovDO): DataSelect2 => {
                  return { text: area.name, id: area.id };
                })}
                options={{
                  placeholder: 'Select user area',
                }}
                onChange={handleSelect2}
                style={{ width: '100%' }}
              />
            )}
          </section>
        </fieldset>
        <fieldset>
          <label className="label">User data</label>
          <div className="row">
            <section className="col col-6">
              <label className="input">
                <i className="icon-append fa fa-user" />
                <input
                  type="text"
                  name="name"
                  placeholder="Full name"
                  value={_.defaultTo(user?.name, '')}
                  onChange={handleChange}
                />
              </label>
            </section>
            <section className="col col-6">
              <label className="input">
                <i className="icon-append fa fa-user" />
                <input
                  type="text"
                  name="info.dni"
                  placeholder="DNI/NIF"
                  value={_.defaultTo(user.info?.dni, '')}
                  onChange={handleChange}
                />
              </label>
            </section>
          </div>
        </fieldset>

        <fieldset>
          <div className="row">
            <section className="col col-6">
              <label className="label">Birthday</label>
              <label className="input">
                <input
                  type="date"
                  name="info.birthdate"
                  value={user.info?.birthdate ? moment(user.info.birthdate).format('YYYY-MM-DD') : ''}
                  className="input-new wdna-fit-date-size"
                  onChange={handleChange}
                />
              </label>
            </section>
            <section className="col col-6">
              <label className="label">Contact</label>
              <label className="input">
                <i className="icon-append fa fa-phone" />
                <input
                  type="tel"
                  name="info.telephone"
                  value={_.defaultTo(user.info?.telephone, '')}
                  placeholder="Phone"
                  onChange={handleChange}
                />
              </label>
            </section>
          </div>
        </fieldset>

        <fieldset>
          <label className="label">Address</label>
          <div className="row">
            <section className="col col-4">
              {countryList && (
                <Select2
                  name="info.country"
                  value={_.defaultTo(user.info?.country, '')}
                  data={countryList.map((item: LovDO): DataSelect2 => {
                    return { id: item.name, text: item.name };
                  })}
                  options={{
                    placeholder: 'Select user country',
                  }}
                  onChange={handleSelect2}
                  style={{ width: '100%' }}
                />
              )}
            </section>

            <section className="col col-4">
              <label className="input">
                <input
                  type="text"
                  name="info.province"
                  value={_.defaultTo(user.info?.province, '')}
                  placeholder="Province"
                  onChange={handleChange}
                />
              </label>
            </section>

            <section className="col col-4">
              <label className="input">
                <input
                  type="text"
                  name="info.city"
                  value={_.defaultTo(user.info?.city, '')}
                  placeholder="City"
                  onChange={handleChange}
                />
              </label>
            </section>
          </div>
          <div className="row">
            <section className="col col-9">
              <label htmlFor="address" className="input">
                <input
                  id="address"
                  type="text"
                  name="info.address"
                  value={_.defaultTo(user.info?.address, '')}
                  placeholder="Street"
                  onChange={handleChange}
                />
              </label>
            </section>
            <section className="col col-3">
              <label className="input">
                <input
                  type="text"
                  name="info.zip"
                  value={_.defaultTo(user.info?.zip, '')}
                  placeholder="Postal Code"
                  onChange={handleChange}
                />
              </label>
            </section>
          </div>
        </fieldset>

        <footer>
          <div className="text-right">
            {loading && <img className="loading-wdna" src="assets/img/loading-wdna.gif" alt="logo" />}
            <button type="submit" className="btn btn-primary">
              Save
            </button>
          </div>
        </footer>
      </form>
    </UiValidate>
  );
}

UserInfo.defaultProps = {
  loading: false,
};
